import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { Partner } from "@emblem/api";

export default /*#__PURE__*/_defineComponent({
  __name: 'PlacesList',
  props: {
    places: null
  },
  setup(__props: any) {



function createDirectionLink(address: string) {
  const url = new URL("https://www.google.com/maps/dir/?api=1");
  url.searchParams.set("destination", address);
  return url.toString();
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    rounded: "",
    class: "overflow-hidden"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "py-0",
        "bg-color": "grey-lighten-3"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.places, (place, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              _createVNode(_component_v_list_item, { class: "pa-2" }, {
                append: _withCtx(() => [
                  (place.phone)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        variant: "plain",
                        icon: "fas fa-phone",
                        href: `tel:${place.phone.replace(/ /g, '')}`
                      }, null, 8, ["href"]))
                    : _createCommentVNode("", true),
                  (place.address)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        variant: "plain",
                        icon: "fas fa-map-location",
                        href: createDirectionLink(place.address),
                        target: "_blank"
                      }, null, 8, ["href"]))
                    : _createCommentVNode("", true)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, { class: "text-wrap flex-grow-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(place.name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              (i < __props.places.length - 1)
                ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})